export default __webpack_public_path__ + "static/planning-recommended-2025-a3e42775ddb262d1504954626f185f83.png";